export function ErrorPage() {
  return (
    <div className="h-full overflow-hidden flex items-center justify-center">
      Something went wrong...
    </div>
  );
}
